import { createAction } from '@reduxjs/toolkit';

export const crudRead = createAction('crud/read');
export const crudDelete = createAction('crud/delete');
export const crudSaveChanges = createAction('crud/saveChanges');
